import React from "react";

import placeholderImage from "../../assets/defaultUser.png";
import { classNames } from "@greeter/util";
import { ContextualBookingStatus, CreatedBy } from "@greeter/core";

import css from "./BookingListItemLabelHeader.module.scss";

import { AppLauncher } from "@capacitor/app-launcher";

export type BookingListItemLabelHeaderProps = {
  createdBy: CreatedBy;
  name: string;
  bookingStatus: ContextualBookingStatus;

  imageUrl?: string;
  phoneNumber?: string;

  // Depends on order status to be overdue
  overdueText?: string;

  className?: string;
};

export function BookingListItemLabelHeader({
  name,
  imageUrl,
  phoneNumber = "+00 0000 0000",
  bookingStatus,
  overdueText,
  createdBy,
  className,
}: BookingListItemLabelHeaderProps) {
  const isCreated = bookingStatus === "created";
  const isPending = bookingStatus === "pending";
  const isAccepted = bookingStatus === "accepted";
  const isOverdue = bookingStatus === "overdue";
  const isMissed = bookingStatus === "missed";
  const isRejected = bookingStatus === "rejected";
  const isInProgress = bookingStatus === "inProgress";
  const isCompleted = bookingStatus === "completed";
  const isRefunded = bookingStatus === "refunded";

  return (
    <div
      {...classNames(
        className,
        css.BookingListItemLabelHeader,
        isPending
          ? css.Pending
          : isAccepted
          ? css.Accepted
          : isRejected
          ? css.Rejected
          : isOverdue
          ? css.Overdue
          : isMissed
          ? css.Missed
          : isInProgress
          ? css.Arrived
          : css.Default
      )}
    >
      <img className={css.ProfileImage} src={imageUrl ?? placeholderImage} />
      <div {...classNames(isCreated ? css.WhiteText : "", css.Info)}>
        <div className={css.OrderStatus}>
          {isCreated ? (
            <span className={css.DefaultOrderStatus}>Afventer betaling!</span>
          ) : isPending ? (
            <span className={css.PendingOrderStatus}>Ny booking! 🥳</span>
          ) : isAccepted ? (
            <span className={css.AcceptedOrderStatus}>
              {createdBy === "venueAdmin" ? "Mangler betaling" : "Godkendt"}
            </span>
          ) : isOverdue ? (
            <span className={css.OverdueOrderStatus}>{overdueText}</span>
          ) : isMissed ? (
            <span className={css.MissedOrderStatus}>Udløbet</span>
          ) : isRejected ? (
            <span className={css.RejectedOrderStatus}>Afvist</span>
          ) : isInProgress ? (
            <span className={css.ArrivedOrderStatus}>
              {createdBy === "venueAdmin" ? "Betalt" : "Ankommet"}
            </span>
          ) : isCompleted ? (
            <span className={css.DefaultOrderStatus}>Afsluttet</span>
          ) : isRefunded ? (
            <span className={css.DefaultOrderStatus}>Refunderet</span>
          ) : (
            <span className={css.DefaultOrderStatus}>{bookingStatus}</span>
          )}
        </div>
        <div className={css.Name}>{name}</div>
        <div
          className={css.PhoneNumber}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            AppLauncher.openUrl({ url: `sms:${phoneNumber}` });
          }}
        >
          {phoneNumber}
        </div>
      </div>
    </div>
  );
}
